export default __webpack_public_path__ + "static/media/background.902cff7a.jpg";